/**
 * Build zamanında env'den okunan özellik bayrakları.
 *
 * Her branch kendi env dosyasıyla derlenir (shipitfile: development → .env.development,
 * preprod → .env.preprod, temp-master → .env.production). Bayrak yalnız değeri tam olarak
 * `'true'` olan env'de açıktır; tanımsız bırakılan her ortamda kapalı kalır.
 */

/** Yabancı yazar süreci (statü 54, İH - Tercüme). Bkz. docs/foreign-author-process.md */
export const isForeignAuthorFeatureEnabled = process.env.REACT_APP_FEATURE_FOREIGN_AUTHOR === 'true';

/** Telif (tasarruf sözleşmesi) ödeme takibi güncellemeleri. BE: `.claude/decisions/disposal-payment-types.md` */
export const isDisposalPaymentFeatureEnabled = process.env.REACT_APP_FEATURE_DISPOSAL_PAYMENT === 'true';

/** Madde grubu ortak kimlik kartı (ana madde + ortaklaştırma). Bkz. docs/article-group-shared-card-context.md */
export const isSharedIdentificationFeatureEnabled = process.env.REACT_APP_FEATURE_SHARED_IDENTIFICATION === 'true';
